import { createTheme } from '@mui/material/styles';

export const colorPalettes = [
  {
name: 'Classic Monochrome',
primary: '#1B4D3E', // Deep Blue replacing green
secondary: '#000000',
background: '#A2B9A7',
text: '#000000',
fontFamily: `Roboto Condensed, sans-serif`,
borderRadius: '5px'

},
{
  name: 'Youthful & Creative',
  primary: '#FF6F00',        // Deep Orange
  secondary: '#00897B',      // Teal
  background: '#FFF3E0',     // Soft Cream
  text: '#263238',           // Charcoal
  fontFamily: 'Nunito, sans-serif',
  borderRadius: '10px'
}


,
  {
    name: 'Autumn Fields',
    primary: '#BB3E00',
    secondary: '#F7AD45',
    background: '#A2B9A7',
    text: '#657C6A',
    fontFamily: `'Fira Code', monospace`,
    borderRadius: '5px'
  },
  
  {
    name: 'Desert Dawn',
    primary: '#E8B059',
    secondary: '#D95555',
    background: '#F4F1EA',
    text: '#5A4739',
    fontFamily: `'Merriweather', serif`,
    borderRadius: '0px'
  },
  {
    name: 'Forest Haven',
    primary: '#2E5E4E',
    secondary: '#BCCC9A',
    background: '#F2F6EC',
    text: '#333D29',
    fontFamily: `'Lora', serif`,
    borderRadius: '10px'
  },
  {
    name: 'Pastel Dreams',
    primary: '#A9D6E5',
    secondary: '#F2C1D1',
    background: '#F8F9FA',
    text: '#61677A',
    fontFamily: `'Dancing Script', cursive`,
    borderRadius: '15px'
  },
  {
    name: 'Midnight Oil',
    primary: '#2B2D42',
    secondary: '#8D99AE',
    background: '#EDF2F4',
    text: '#EF233C',
    fontFamily: `'Source Code Pro', monospace`,
    borderRadius: '0px'
  }
];
  

  export const createAppTheme = (paletteIndex: number) => {
    const currentPalette = colorPalettes[paletteIndex % colorPalettes.length];
    
    return createTheme({
      palette: {
        mode: paletteIndex === 1 ? 'dark' : 'light', // auto dark mode for Ocean Night
        primary: { main: currentPalette.primary },
        secondary: { main: currentPalette.secondary },
        background: { default: currentPalette.background },
        text: { primary: currentPalette.text }
      },
      typography: {
        fontFamily: currentPalette.fontFamily,
        h1: { fontWeight: 700, fontSize: '2.5rem' },
        h2: { fontWeight: 600, fontSize: '2rem' },
        body1: { fontSize: '1rem', lineHeight: 1.6 },
        button: { textTransform: 'none', fontWeight: 600 }
      },
      shape: {
        borderRadius: parseInt(currentPalette.borderRadius)
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: currentPalette.borderRadius,
              fontWeight: 'bold',
              padding: '0.5rem 1.2rem'
            }
          }
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundColor: currentPalette.background,
              borderRadius: currentPalette.borderRadius
            }
          }
        }
      }
    });
  };
  